import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import axios from "axios";

export const login = (creds, onComplete = () => {}) => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN_REQUEST",
    });
    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then((data) => {
        var docRef = firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid);
        docRef.get().then((doc) => {
          if (doc.exists) {
            if (doc.data().blocked) {
              toast.warning("You are not allowed to access this panel");
              dispatch({
                type: "LOGIN_REQUEST_END",
              });
              onComplete();
            } else {
              if (
                doc.data().role == "school-admin" ||
                doc.data().role == "school-sub-admin"
              ) {
                if (doc.data().status) {
                  if (doc.data().status == "approved") {
                    docRef.update({
                      lastLoggedIn:
                        firebase.firestore.FieldValue.serverTimestamp(),
                    });
                    dispatch(refreshAuth(data.user.uid));
                    onComplete();
                  } else if (doc.data().role == "school-sub-admin") {
                    docRef.update({
                      lastLoggedIn:
                        firebase.firestore.FieldValue.serverTimestamp(),
                    });
                    dispatch(refreshAuth(data.user.uid));
                    onComplete();
                  } else {
                    toast.warning("Please wait for admin approved");
                    onComplete();
                  }
                } else {
                  docRef.update({
                    lastLoggedIn:
                      firebase.firestore.FieldValue.serverTimestamp(),
                  });
                  dispatch(refreshAuth(data.user.uid));
                  onComplete();
                }
              } else {
                toast.warning("You are not allowed to access this panel");
                dispatch({
                  type: "LOGIN_REQUEST_END",
                });
                onComplete();
              }
            }
          } else {
            toast.warning("You are not allowed to access this panel");
            dispatch({
              type: "LOGIN_REQUEST_END",
            });
            onComplete();
          }
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGIN_FAIL",
          uid: "",
          error: error,
        });
        dispatch({
          type: "LOGIN_REQUEST_END",
        });
        toast.warning("Invalid credentials, please try again.");
        onComplete();
      });
  };
};
export const refreshAuth =
  (id, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .doc(id)
      .onSnapshot((doc) => {
        dispatch({
          type: "LOGIN_SUCCESS",
          user: { id: doc.id, ...doc.data() },
          error: "",
        });
        dispatch({
          type: "LOGIN_REQUEST_END",
        });
        onComplete();
      });
  };
export const logout = () => {
  return (dispatch) => {
    firebase
      .auth()
      .signOut()
      .then((data) => {
        dispatch({
          type: "LOGOUT_SUCCESS",
          uid: "",
          user: "",
          error: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGOUT_FAIL",
          uid: "",
          error: error,
        });
      });
  };
};
export const forgetPassword = (email, onComplete = () => {}) => {
  return (dispatch) => {
    dispatch({
      type: "ACTION_FORGET_REQUEST",
    });
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((res) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.success("Recovery Email Sent");
        onComplete();
      })
      .catch((err) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.warning(err.message);
        onComplete();
      });
  };
};
export const updatePasswordUser = (obj, onComplete = () => {}) => {
  return (dispatch) => {
    dispatch({
      type: "PASSWORD_REQUEST",
    });
    let user = firebase.auth().currentUser;
    if (user != null) {
      let creds = firebase.auth.EmailAuthProvider.credential(
        user.email,
        obj.currentPassword
      );
      user
        .reauthenticateWithCredential(creds)
        .then(() => {
          user.updatePassword(obj.newPassword);
          dispatch({
            type: "PASSWORD_REQUEST_END",
          });
          toast.success("Password Updated Successfully");
          onComplete("success");
        })
        .catch((error) => {
          toast.warning("Current Password is Invalid");
          dispatch({
            type: "PASSWORD_REQUEST_END",
          });
          onComplete();
        });
    } else {
      dispatch({
        type: "PASSWORD_REQUEST_END",
      });
      onComplete();
    }
  };
};

export const register =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    console.log(data, "register>>>>>>>>>>>");
    let { password, img, ...newData } = data;
    firebase
      .auth()
      .createUserWithEmailAndPassword(data.email, data.password)
      .then(async (res) => {
        if (newData != null) {
          var imgName = data.img.name;
          let ext2 = imgName.slice(imgName.lastIndexOf("."));
          var img_name = res.user.uid + ext2.toLowerCase();
          var imgLets = await firebase
            .storage()
            .ref("school_admin_files/" + res.user.uid + ext2.toLowerCase())
            .put(data.img);
          var imgURL = await imgLets.ref.getDownloadURL();
          let notificationData = {
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            notifyID: res.user.uid,
            image: imgURL,
            status: false,
          };
          if (data.type === "school platform") {
            notificationData.type = "school";
          } else {
            notificationData.type = data.type;
          }
          console.log(notificationData, "notificationData>>>>>>>>>>>>>>");
          await firebase
            .firestore()
            .collection("admin_notifiaction")
            .add(notificationData);
          firebase
            .firestore()
            .collection("users")
            .doc(res.user.uid)
            .set({
              ...newData,
              admin_image: {
                file_name: img_name,
                url: imgURL,
              },
            })
            .then(async (res) => {
              if (newData.role == "school-sub-admin") {
                dispatch({
                  type: "SUB_ADMIN-REGISTER",
                  payload: {
                    ...newData,
                    admin_image: {
                      file_name: img_name,
                      url: imgURL,
                    },
                  },
                });
              }
              toast.success("Account Created Successfully");
              onSuccess("success");
            })
            .catch((error) => {
              onSuccess();
              console.log(error.message);
              toast.warning(error.message);
            });
        }
      })
      .catch((error) => {
        onSuccess();
        toast.warning(error.message);
      });
  };
export const isSchoolExist =
  (obj, onComplete = () => {}) =>
  async () => {
    console.log("school exist>>>>>>>>>>>");
    await firebase
      .firestore()
      .collection("users")
      .where("email", "==", obj.email)
      .get()
      .then(async (query) => {
        if (query.empty) {
          if (obj.password.length > 6) {
            firebase
              .firestore()
              .collection("users")
              .where("state", "==", obj.state)
              .where("county", "==", obj.county)
              .where("instituteName", "==", obj.instituteName)
              .where("type", "==", obj.type)
              .get()
              .then(async (res) => {
                if (res.docs.length == 0) {
                  onComplete("success");
                } else {
                  onComplete({ ...res.docs[0].data(), id: res.docs[0].id });
                }
              });
          } else {
            toast.warning("Please enter password minimum 7 character");
            onComplete("error");
          }
        } else {
          toast.warning("This email already exist");
          onComplete("error");
        }
      });
  };

export const adminChangeRequest =
  (obj, onComplete = () => {}) =>
  async () => {
    console.log("admin change>>>>>>>>>>>", obj);
    let { img, ...newData } = obj;
    console.log(newData, "newData>>>>>>>");
    var imgName = obj.img.name;
    let ext2 = imgName.slice(imgName.lastIndexOf("."));
    var img_name = obj.schoolAdminId + ext2.toLowerCase();
    var imgLets = await firebase
      .storage()
      .ref("school_admin_files_request/" + ext2.toLowerCase())
      .put(obj.img);
    var imgURL = await imgLets.ref.getDownloadURL();
    await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .add({
        ...newData,
        admin_image: {
          file_name: img_name,
          url: imgURL,
        },
      });
    if (newData.type === "school platform") {
      let notificationData = {
        type: "school-admin-change",
        notifyID: newData?.schoolAdminId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        image: imgURL,
        status: false,
      };
      console.log(notificationData, "notificationData>>>>>>>>>>>>>>");
      await firebase
        .firestore()
        .collection("admin_notifiaction")
        .add(notificationData);
    }
    onComplete();
    toast.success("Send request successfully");
  };

export const emailForChangingRequest = (data) => async () => {
  console.log("email for changing request>>>>>>>>>>>");
  console.log(data);
  const athleteResponseEmailNew = `NOTICE – FansHelpPlayers records indicate that an Intellectual Property (IP) Contract for your school already exists with the following School Official assigned: Name : ${data.adminName}, Email: ${data.adminEmail}-. Meanwhile, a second School Official Name: ${data.requestName}, Email: ${data.requestEmail}has attempted to also register an Intellectual Property (IP) Contract for your school. Please coordinate to prevent double registration. Please alert FansHelpPlayers at fanshelpplayers.com if your school registration needs adjustment. 
    `;
  const options = {
    to: [data.adminEmail, data.requestEmail],
    subject: "Request For New Admin",
    text: athleteResponseEmailNew,
  };
  axios.post(
    "https://us-central1-fans-help-players.cloudfunctions.net/app/sendUserEmail",
    options
  );
};

export const updateContestStatus = ({ uid, showContests }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await firebase.firestore().collection("users").doc(uid).update({
          showContests,
        });
        toast.success("Contest status updated successfully!");
        dispatch({
          type: "UPDATE_CONTEST_STATUS",
          payload: showContests,
        });
        resolve(null);
      } catch (error) {
        toast.error(error.message || "Unable to update contest status");
        reject(error);
      }
    });
  };
};
